import { navigate, useLocation } from '@reach/router';
import { graphql } from 'gatsby';
import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import './teamGrid.scss';
import TeamGridMember, { TeamGridMemberProps } from './teamGridMember';
import gsap from 'gsap';
import classNames from 'classnames';
import TeamGridModal from './modal/teamGridModal';

interface Props {
  teamHeadline?: string;
  teamCategory: {
    team: {
      nodes: TeamGridMemberProps[];
    };
  };
}

const TeamGrid: React.FC<Props> = (props) => {
  const [teamActive, setTeamActive] = useState<TeamGridMemberProps | null>();
  const [indexActive, setIndexActive] = useState<number>(-1);
  const [activeHeight, setActiveHeight] = useState<number>(0);
  const [isMobile, setIsMobile] = useState<boolean>(false);
  const mainRef = useRef<HTMLDivElement>(null);
  const mobileRef = useRef<HTMLDivElement>(null);
  const activeRefs = useRef<any[]>([]);
  const location = useLocation();

  useLayoutEffect(() => {
    const handleResize = () => {
      let isMobile = !!(mobileRef.current && window.getComputedStyle(mobileRef.current).display !== 'none');
      setIsMobile(isMobile);

      if (indexActive >= 0) {
        const activeElement = activeRefs.current[indexActive];
        if (!!activeElement) {
          setActiveHeight(activeElement.clientHeight);
        }
      } else {
        setActiveHeight(0);
      }

      // if (!isMobile) {
      //   const main = mainRef.current;
      //   if (!!main) {
      //     const mainTop = main.getBoundingClientRect().top - 160;
      //     if (mainTop < 0) {
      //       gsap.to(window, {
      //         duration: 0.4,
      //         scrollTo: window.scrollY + mainTop,
      //       });
      //     }
      //   }
      // }
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [indexActive]);

  useEffect(() => {
    let _teamActive = null;
    let indexActive = -1;
    props.teamCategory.team.nodes.forEach((item, key) => {
      const isActive = `#${item.slug}` === location.hash;
      isActive && (indexActive = key);
      isActive && (_teamActive = item);
    });
    setTeamActive(_teamActive);
    setIndexActive(indexActive);
  }, [location.hash]);

  const handleModalClose = () => {
    navigate('/' + location.pathname.replaceAll("/", ""))
    // window.location = location.pathname.replaceAll("/", "")
  }

  // console.log('is-mobile', isMobile)

  console.log(props);

  return (
    <>
      {!!props.teamHeadline && (
        <div className="section-header">
          <h5 className="section-header__title">{props.teamHeadline}</h5>
        </div>
      )}

      <div className="team-grid" ref={mainRef}>
        <div className="team-grid__mobile-dummy" ref={mobileRef} />
        <div className="grid-row">
          {props.teamCategory.team.nodes.map((item, key) => (
            <div className="team-grid__cell grid-cell" key={key}>
              <TeamGridMember
                {...item}
                isInActive={indexActive > -1 && indexActive !== key}
                isActiveMobile={indexActive === key && isMobile}
                key={key}
                isMobile={isMobile}
              />
            </div>
          ))}
        </div>
      </div>

      {!!teamActive && !isMobile && <TeamGridModal member={teamActive} onClose={handleModalClose} />}
    </>
  );
};

export default TeamGrid;

export const query = graphql`
  fragment TeamGridBlock on WpAcfTeamgridBlock {
    AcfTeamGrid {
      teamHeadline
      teamCategory {
        team {
          nodes {
            slug
            title
            content
            teamMember {
              position
              title
              contactSocial {
                platform
                link
              }
              cv {
                mediaItemUrl
              }
            }
            featuredImage {
              node {
                localFile {
                  childImageSharp {
                    gatsbyImageData(width: 800, quality: 90)
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
